
import React from 'react';

interface UpdateRSVPErrorProps {
  error: Error | null;
}

export const UpdateRSVPError: React.FC<UpdateRSVPErrorProps> = ({ error }) => {
  return (
    <div className="text-center p-6 text-red-500">
      <h3 className="text-lg font-semibold mb-2">Error</h3>
      <p>{error?.message || 'An error occurred'}</p>
    </div>
  );
};
